import { Component, Input, OnInit } from '@angular/core';
import jsPDF from 'jspdf';
import * as JsBarcode from 'jsbarcode';
import { Mercaderia } from 'src/app/model/index.model';

@Component({
  selector: 'app-imp-code-bar',
  templateUrl: './imp-code-bar.component.html',
  styleUrls: ['./imp-code-bar.component.css']
})
export class ImpCodeBarComponent implements OnInit {
  // Asumiendo que tenés el producto cargado
  @Input() producto: Mercaderia;
  @Input() conf: any;
  @Input() grande: boolean = true;

  logoUrl = 'assets/img/logo.png';  // ← poné tu logo aquí (PNG preferible, 200-300px ancho)
  anchoMm = 50;   // ancho fijo (ajusta según tu rollo)
  altoMm = 70;   // altura total (ajusta según necesidad)

  constructor() { }

  ngOnInit() {
  }


  generarEtiquetaPDF() {
    if (this.grande) {
      this.anchoMm = this.conf.barrGr.anchoMm;
      this.altoMm = this.conf.barrGr.altoMm;
    } else {
      this.anchoMm = this.conf.barrCh.anchoMm;
      this.altoMm = this.conf.barrCh.altoMm;

    }

    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [this.anchoMm, this.altoMm]
    });

    // Fondo blanco
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, this.anchoMm, this.altoMm, 'F');

    // Alturas por porcentaje
    const logoHeightPct = 0.18;   // 15%
    const nombreHeightPct = 0.30;   // 25%
    const barcodeHeightPct = 0.25;   // 30%
    const infoHeightPct = 0.27;   // 30%

    // Calcular posiciones Y acumuladas
    let currentY = 0;

    // 1. Logo (15%)
    const logoSectionHeight = this.altoMm * logoHeightPct;
    const logoMaxWidth = this.anchoMm * 0.70;
    const logoMaxHeight = logoSectionHeight * 0.9;  // 80% del sector para margen

    const dibujarResto = () => {
      // 2. Nombre del producto (25%)
      const nombreSectionHeight = this.altoMm * nombreHeightPct;
      let fontSizeNombre = 12;
      doc.setFont('helvetica', 'bold');
      let nombre = this.producto.nombre.toUpperCase();

      doc.setFontSize(fontSizeNombre);
      while (doc.getTextWidth(nombre) > this.anchoMm - 12 && fontSizeNombre > 8) {
        fontSizeNombre -= 0.5;
        doc.setFontSize(fontSizeNombre);
      }

      const nombreY = currentY + (nombreSectionHeight / 2) + (fontSizeNombre / 3); // centrado vertical
      doc.text(nombre, this.anchoMm / 2, nombreY, {
        align: 'center',
        maxWidth: this.anchoMm - 12
      });
      currentY += nombreSectionHeight;

      // 3. Código de barras (30%)
      const barcodeSectionHeight = this.altoMm * barcodeHeightPct;

      const barcodeY = currentY + 4;  // pequeño margen arriba
      const barcodeCanvas = document.createElement('canvas');
      JsBarcode(barcodeCanvas, this.producto.serie || 'SIN CODIGO', {
        format: 'CODE128',
        displayValue: false,
        /* 
           width: 2,
           height: barcodeSectionHeight * 0.65,  // 65% del sector para dejar espacio al texto
           fontSize: 12,
           margin: 3,
           textAlign: 'center',
           textPosition: 'bottom',
           textMargin: 2,
        */
        flat: true
      });

      const barcodeImg = barcodeCanvas.toDataURL('image/png');
      doc.addImage(barcodeImg, 'PNG', 6, barcodeY, this.anchoMm - 12, barcodeSectionHeight - 6);
      currentY += barcodeSectionHeight;

      // 4. Precio (integrado en la sección de info o justo debajo del barcode)
      /*
      doc.setFontSize(16);
      doc.setTextColor(0, 128, 0);
      doc.setFont('helvetica', 'bold');
      const precio = `$${this.producto.precioCon?.toLocaleString('es-AR') || '0.00'}`;
      doc.text(precio, this.anchoMm / 2, currentY - 8, { align: 'center' });  // justo arriba de info
      */
      // 5. Información final (30%)
      const infoSectionHeight = this.altoMm * infoHeightPct;
      doc.setFontSize(8);
      doc.setTextColor(70, 70, 70);
      doc.setFont('helvetica', 'normal');

      const infoY = currentY + 4;
      doc.text(`SKU: ${this.producto.serie || '—'}`, 6, infoY);
      doc.text(this.conf.tit, 6, infoY + 5);
      doc.text(this.conf.dir, 6, infoY + 10);
      doc.text(this.conf.loc, 6, infoY + 15);

      // Guardar para pruebas (comenta después)
      // doc.save(`etiqueta-${this.producto.serie || 'test'}.pdf`);

      // Imprimir
      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = pdfUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.focus();
          iframe.contentWindow?.print();
        }, 1500);
      };
    };
    if (this.logoUrl) {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = this.logoUrl;

      const onImageLoad = () => {
        let w = img.width;
        let h = img.height;
        const ratio = w / h;

        if (w > logoMaxWidth) { w = logoMaxWidth; h = w / ratio; }
        if (h > logoMaxHeight) { h = logoMaxHeight; w = h * ratio; }

        doc.addImage(img, 'PNG', (this.anchoMm - w) / 2, currentY + 3, w, h);
        currentY += logoSectionHeight;
        dibujarResto();
      };

      img.onload = onImageLoad;

      // Si ya está en caché, ejecutamos inmediatamente
      if (img.complete) {
        onImageLoad();
        return;  // salimos para evitar doble ejecución
      }
    } else {
      // Placeholder sin logo
      doc.setFontSize(10);
      doc.text('MyL', this.anchoMm / 2, currentY + 10, { align: 'center' });
      currentY += logoSectionHeight;
      dibujarResto();
    }
    // Iniciar
    //agregarContenido();
  }

}
